import { missingNativeBuild } from "../nativeError";
var LocalAuthentication = Object.freeze({
  canEvaluatePolicy: function canEvaluatePolicy() {
    return {
      available: false,
      biometryType: "none"
    };
  },
  evaluatePolicy: function evaluatePolicy(_reason) {
    return Promise.reject(missingNativeBuild("LocalAuthentication.evaluatePolicy"));
  }
});
export {
  LocalAuthentication
};
//# sourceMappingURL=unavailable.js.map
